export default __webpack_public_path__ + "static/Supreme-Bold-a703df15b0fb94de0afa24be79dc369c.woff2";